import { render, staticRenderFns } from "./ywBooks.vue?vue&type=template&id=7b95d704&scoped=true&"
import script from "./ywBooks.vue?vue&type=script&lang=js&"
export * from "./ywBooks.vue?vue&type=script&lang=js&"
import style0 from "./ywBooks.vue?vue&type=style&index=0&id=7b95d704&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b95d704",
  null
  
)

export default component.exports